import { CreatedDeleteButton } from '@/features/delete';
import url from '@/shared/lib/url';
import { useRouter } from '@tanstack/react-router';
import { deleteButtonStyles, createdRangeButtonStyles, cteatedEditButtonStyles } from './styles';
import { CreatedRange } from '@/features/created-range';
import { PublishButton } from '@/features/publish';
import { FC } from 'react';
import moment from 'moment';
import { difyMap } from '@/shared/utils/created';
import { CreatedEditButton } from '@/features/edit/ui/created-edit-button';

interface CreatedBoxListTypeProps {
    data: DATA.Exam;
    index: number;
    checked: boolean;
    handleCheck: (data: DATA.Exam) => void;
    onSelect: (data: DATA.Exam) => void;
    onRefetch: () => void;
}

export const CreatedBoxListType: FC<CreatedBoxListTypeProps> = ({
    data,
    checked,
    handleCheck,
    onSelect,
    onRefetch,
}) => {
    const router = useRouter();
    const goToCreatedDetail = () => {
        const examId = data.examId;
        router.navigate({ to: `/sets/created-box/detail/${examId}` });
    };

    type Grouped = Record<string, number>;
    const grouped = data?.articleTypeList.reduce((acc, { articleType, articleTypeCnt }) => {
        const groupKey = articleType === '문항' || articleType === '활동' ? '문항' : articleType;
        acc[groupKey] = (acc[groupKey] || 0) + articleTypeCnt;
        return acc;
    }, {} as Grouped);

    // 객체를 배열의 객체 형태로 변환
    const articleCountArray = Object.entries(grouped).map(([articleType, articleTypeCnt]) => ({
        articleType,
        articleTypeCnt,
    }));

    return (
        <li>
            <span className="label-wrap">
                {data?.difyNm && data?.curriSubject === 'mathematics' && (
                    <span className={`viewlabel1 ${difyMap[data?.difyNm]}`}>{data?.difyNm}</span>
                )}
                {/* {articleCountArray?.map((e, i) => (
                    <span key={`list-articleType-${i}`} className="viewlabel2">
                        {e.articleType} {e.articleTypeCnt}개
                    </span>
                ))} */}
                <span key={`list-articleType-${0}`} className="viewlabel2">
                    {'문항'} {data.mdulCnt}개
                </span>
            </span>
            <button type="button" className="thumb" onClick={goToCreatedDetail}>
                <span className="type">{data?.curriBookNm ?? '교과 자료'}</span>
                <img src={url.src(data?.thumbnail) ?? ''} alt="thumbnail" />
                {/* <div className="preview-layer">
                    <div className="preview">
                        <img src={url.src(data?.thumbnail) ?? ''} alt="thumbnail" />
                    </div>
                </div> */}
            </button>

            <div className="info">
                <div className="title_wrap">
                    <button type="button" className="data-title" onClick={goToCreatedDetail}>
                        {data?.name}
                    </button>
                    <span className="edit_date">
                        {/*<i></i>*/}
                        {data?.rdate ? moment(data?.rdate).format('YYYY-MM-DD HH:mm') : ''}
                        {data?.version > 1 && ' 수정'}
                    </span>
                </div>

                <span className="chk">
                    <input
                        type="checkbox"
                        id={`chk1-${data?.examId}`}
                        name="chk"
                        value={data?.examId}
                        checked={checked}
                        onChange={() => handleCheck(data)}
                    />
                    <label htmlFor={`chk1-${data?.examId}`}>
                        <i></i>
                    </label>
                </span>

                <button className="ico-publication" onClick={() => onSelect(data)}>
                    {data?.publishCnt}
                </button>

                <CreatedRange
                    articleList={data?.articleList.map((e) => e.id) ?? []}
                    styles={createdRangeButtonStyles}
                    disabled={data?.examScopeExistYn === 'N'}
                >
                    출제범위
                </CreatedRange>

                <div className="btm-info ttukttak_btm-info">
                    <CreatedDeleteButton
                        buttonText="삭제"
                        checkList={[data.examId.toString()]}
                        showTooltip={true}
                        styles={deleteButtonStyles}
                        onRefetch={onRefetch}
                    />
                    <CreatedEditButton
                        examId={data.examId}
                        examName={data.name}
                        showTooltip={true}
                        styles={cteatedEditButtonStyles}
                        onRefetch={onRefetch}
                        examSetId={data.setsId}
                        buttonText="편집"
                        curriBook={data.curriBook}
                        subjectId={data.curriSubjectId}
                        textbookId={data.textbkId}
                    />
                    <PublishButton
                        checkList={[data]}
                        showTooltip={true}
                        styles={{ button: 'btn btn-icon modify-publication' }}
                        buttonText="발행"
                    />
                </div>
            </div>
        </li>
    );
};
